export enum UserManagementPermissions {
	undefined = 0,
	deletelink = 1,
	runlink = 2,
	editlink = 3,
	createlink = 4,
	enableordisablelink = 5,
	cspaccessmockdata = 6,
	cspfsaccessmockdata = 7,
	canviewapplicationlogs = 8
}
